import { useState, useCallback } from "react";

/**
 * useSearch hook - manages search term state for server-side search
 * Note: The actual filtering is now done server-side, not client-side.
 * This hook only manages the search term state.
 */
export const useSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const updateSearchTerm = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchTerm("");
  }, []);

  return {
    searchTerm,
    setSearchTerm: updateSearchTerm,
    clearSearch,
  };
};
